import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 text-left border-b-2 border-green-show" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "SNS連携")
], -1)
const _hoisted_4 = { class: "py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SProfileSnsCell = _resolveComponent("SProfileSnsCell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SProfileSnsCell)
      ])
    ])
  ]))
}